import { render } from "./WhyItMatter.vue?vue&type=template&id=5701b77c&scoped=true"
import script from "./WhyItMatter.vue?vue&type=script&lang=js"
export * from "./WhyItMatter.vue?vue&type=script&lang=js"

import "./WhyItMatter.vue?vue&type=style&index=0&id=5701b77c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5701b77c"]])

export default __exports__